import $ from 'jquery';
import run from '../../utilities/run';
import { isPresent, isBlank } from '../../utilities/general';
import render from "../../utilities/render";
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import walmartReviewTab from './walmartReviewTab';
import walmartConnectionTab from './walmartConnectionTab';
import walmartConfigurationTab from './walmartConfigurationTab';

run("#create-walmart-channel-form", (el) => {
  attachWizard(el);
  setupEditChecker();
});

function setupEditChecker() {
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#create-walmart-channel-form");
  EditChecker.bindCancelButton("#create-walmart-channel-cancel-btn");
}

function attachWizard(el) {
  const wizardElement = el;
  const retpartner = wizardElement.data("retailer-partners-info");

  const validator = el.validate({
    errorPlacement: function (error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  });

  validator.settings.ignore = ":disabled,:hidden";

  const quickWizard = new QuickWizard(el, {
    tabletWidthNavStep: 902,
    mobileWidthNavStep: 502,

    shouldNavigateToForm: ({ targetForm, direction, currentForm, done }) => {
      // Any time we go traverse backwards, just let us
      if (direction === "BACKWARDS") {
        return true;
      }

      // handle general validations on forward traversal
      let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
      if(currentForm.filter('.configurations-tab').length) {
        return configTab.didNavigateToForm();
      }

      if (targetForm.filter('.configurations-tab').length || targetForm.filter('.review-tab').length) {
        return connectionTab.areInputsValidForForm();
      } else if (!quickWizard.areInputsValid(allPrevInputs, { displayErrors: true })) {
        quickWizard.goToFirstIncompleteForm();
        return false;
      }
    },
    didNavigateToForm: function ({ currentForm }) {
      if (currentForm.filter('.connections-tab').length) {  
        connectionTab.didNavigateToForm();
      } else if (currentForm.filter('.configurations-tab').length) { 
        configTab.didNavigateToForm();
      } else if (currentForm.filter('.review-tab').length) {
        reviewTab.didNavigateToForm();
      }
    }
  });

  quickWizard.init();

  function canSave(quickWizard) {
    const currentForm = quickWizard.getActiveTargetForm();
    let isValid = true;
    if (currentForm.filter(".connection-tab").length) {
      isValid = areInputsValidForForm(currentForm);
    }
    return isValid;
  }
  
  const connectionTab = new walmartConnectionTab(quickWizard); 
  connectionTab.init();

  const configTab = new walmartConfigurationTab(quickWizard);
  configTab.init();

  const reviewTab = new walmartReviewTab(quickWizard);
  reviewTab.init();
}



// WEBPACK FOOTER //
// ./src/pages/createChannel/createWalmartChannel.js